module.exports = __webpack_public_path__ + "img/welfare-ico-1.4ec7a2bf.png";